/**
 * Check if the current device is mobile
 * @returns {boolean} - True if mobile, false otherwise
 */
export const isMobile = () => {
	const isMobileWidth = window.innerWidth <= 768;

	const userAgent = navigator.userAgent || navigator.vendor || window.opera;
	const mobileRegex =
		/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i;
	const isMobileUserAgent = mobileRegex.test(userAgent);

	return isMobileWidth || isMobileUserAgent;
};

/**
 * Check if the current device is iOS (iPhone/iPad), independent of viewport
 * width. iPadOS 13+ reports its UA as "Macintosh" with no "iPad" substring
 * unless "Request Mobile Website" is on, so a landscape/full-size iPad can
 * pass neither of isMobile()'s checks; maxTouchPoints disambiguates a real
 * iPad from a real (non-touch) Mac.
 * @returns {boolean} - True if iOS, false otherwise
 */
export const isIosDevice = () => {
	const userAgent = navigator.userAgent || navigator.vendor || window.opera;
	const isIosUserAgent = /iphone|ipad|ipod/i.test(userAgent);
	const isIpadOSMacUa =
		navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;

	return isIosUserAgent || isIpadOSMacUa;
};
